<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-stati-patrimoniali page-operative-data-analysis-stati-patrimoniali-edit">
    <div class="container">
      <PageTitle>Modifica Stato Patrimoniale</PageTitle>

      <div v-if="loading">LOADING ...</div>
      <div v-else-if="errorLoadingData">Stato Patrimoniale da modificare non trovato</div>
      <FormStatoPatrimoniale v-else-if="company && userCanEdit" :statoPatrimoniale.sync="statoPatrimoniale" edit @saved="saveStatoPatrimoniale" />
      <div v-else-if="company">Utente non abilitato</div>
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-stati-patrimoniali-edit',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormStatoPatrimoniale: () => import('../../../../components/Operative/Form/FormStatoPatrimoniale'),
  },
  data () {
    return {
      statoPatrimoniale: null,
      loading: true,
      errorLoadingData: false,
    };
  },
  methods: {
    saveStatoPatrimoniale (statoPatrimoniale) {
      this.$api.updateStatoPatrimoniale(this.company.id, statoPatrimoniale.id, statoPatrimoniale)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.stati-patrimoniali',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
  mounted () {
    this.loading = true;
  },
  watch: {
    company: {
      immediate: true,
      handler: function () {
        if (!this.company) {
          return;
        }

        this.$api.getStatoPatrimoniale(this.company.id, this.$route.params.statoPatrimonialeId)
          .then(res => {
            this.statoPatrimoniale = res.data;
          })
          .catch(err => {
            this.errorLoadingData = true;
            this.$log.error(err);
          })
          .finally(() => {
            this.loading = false;
          })
        ;
      },
    },
  },
};

</script>
